import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

const $filters = $('.filter');
const $body = $('body');
const log = debug("filters");


function sliderFix() {
	// Fix for slick sliders that are hidden
	window.ctia_sliders.forEach(slider => {
		slider.slick('setPosition');
		setTimeout(() => {
			slider.slick('setPosition');
		}, 100);
	})
}

function closeFilter($this) {
	let $filter = $this.closest('.filter');
	$filter.removeClass('filter--open');
}

function changeFilterText($this) {
	let $filter = $this.closest('.filter');
	let text = $this.text();

	$filter.find('.filter__toggle__text').text(text);
}

function filter_toggle() {
	$filters.on('click', '.filter__toggle', function () {
		let $this = $(this);
		let $filter = $this.closest('.filter');

		$filter.addClass('filter--active');
		$('.filter--open').not('.filter--active').removeClass('filter--open');
		$filter.removeClass('filter--active').toggleClass('filter--open');
	});

	$body.on('click', function (e) {
		e.stopPropagation();
		if (!$(event.target).closest('.filter').length) {
			$('.filter--open').removeClass('filter--open');
		}
	});
}

function filter_section() {
	$('[data-type="section-toggle"]').on('click', '.filter__trigger', function () {

		let $this = $(this);
		let which = $this.closest('.filter__item').prevAll().length;
		let $filter_sections = $this.closest('.filter-section').find('.filter-sections');
		let $fs_children = $filter_sections.children()

		$fs_children.addClass('is-hidden').removeClass('is-showing');
		$fs_children.eq(which).removeClass('is-hidden').addClass('is-showing');

		changeFilterText($this);
		closeFilter($this);
		sliderFix();
	});
}

export function init() {
	if ($filters.length) {
		filter_toggle();

		filter_section();
	}
}

export default {
	init
};
